import Vue from 'vue'
import Vuex from 'vuex'
import biblioteca from './modules/biblioteca'
import curso from './modules/curso'
import menu from './modules/menu'
import alumno from './modules/alumno'
import evaluacion from './modules/evaluacion'
import certificado from './modules/certificado'
import alumnoCurso from './modules/alumnoCurso'
import modulo from './modules/modulo'
import profesor from './modules/profesor'
import evaluacionAlumno from './modules/evaluacionAlumno'
import campus from './modules/campus'

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        accessToken: '' || localStorage.getItem('accessToken'),
        autenticado: false || localStorage.getItem('autenticado')
    },
    mutations: {
        SET_ACCESS_TOKEN(state, token){
			localStorage.setItem('accessToken', token);
			localStorage.setItem('autenticado', true);
			state.accessToken = token;
			state.autenticado = true;
        },
        REMOVE_ACCESS_TOKEN(state){
			localStorage.removeItem('accessToken');
            localStorage.removeItem('autenticado');
            localStorage.removeItem('coordinadora'); 
            localStorage.removeItem('usuarioDB');
            localStorage.removeItem('campusSeleccionadoMulti'); 
            
            state.accessToken = '';
            state.coordinadora = '';
            state.autenticado = false;
        },
    },
    actions: {
        setAccessToken(context, token){
			context.commit('SET_ACCESS_TOKEN', token);
        },      
		removeAccessToken(context){
			context.commit('REMOVE_ACCESS_TOKEN');
        },
        
    },
    getters:{
        estaActivo: state => !!state.token
    },
    modules: {
        biblioteca,
        curso,
        menu,
        alumno,
        evaluacion,
        certificado,
        alumnoCurso,
        modulo,
        profesor,
        evaluacionAlumno,
        campus
    }
})
